// import React, { useRef, useState } from "react";
// import "./Navbar.css";
// import { Link } from "react-router-dom";
// import logo from "../Assets/world-dominators1.png";
// import nav_dropdown from "../Assets/nav_dropdown.png";

// const Navbar = () => {
//   const [menu, setMenu] = useState("home");
//   const menuRef = useRef();

//   const dropdown_toggle = () => {
//     menuRef.current.classList.toggle("nav-menu-visible");
//   };

//   // ✅ MAP MENU TO YOUR EXISTING ROUTES
// const routes = {
//   Home: "/",
//   AI: "/ai",
//   "Graphics Template": "/graphics", // fixed path (adjust if needed)
//   "Media Template": "/media",
//   "Tech Space": "/t-space",   // you can adjust these
//   Tutorials: "/tutorial",
// };
//   return (
//     <div className="nav">
//       {/* LOGO */}
//       <Link to="/" onClick={() => setMenu("home")} className="nav-logo">
//         <img src={logo} alt="logo" />
//         {/* <p>WDH</p> */}
//       </Link>

//       {/* MOBILE MENU ICON */}
//       <img
//         onClick={dropdown_toggle}
//         className="nav-dropdown"
//         src={nav_dropdown}
//         alt="menu"
//       />

//       {/* NAV LINKS */}
//       <ul ref={menuRef} className="nav-menu">
//         {Object.keys(routes).map((item) => (
//           <li key={item} onClick={() => setMenu(item)}>
//             <Link to={routes[item]}>
//               {item.charAt(0).toUpperCase() + item.slice(1)}
//             </Link>
//             {menu === item && <hr />}
//           </li>
//         ))}
//       </ul>

//       {/* RIGHT SIDE */}
//       <div className="nav-right">
//         {localStorage.getItem("auth-token") ? (
//           <button
//             onClick={() => {
//               localStorage.removeItem("auth-token");
//               window.location.replace("/");
//             }}
//           >
//             Logout
//           </button>
//         ) : (
//           <Link to="/login">
//             <button>Login</button>
//           </Link>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Navbar;



import React, { useRef, useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import logo from "../Assets/world-dominators1.png";
// Replace the previous dropdown icon with a hamburger icon
// import nav_dropdown from "../Assets/hamburger.png"; // use your three-line icon image
import nav_dropdown from "../Assets/nav_dropdown.png";
const Navbar = () => {
  const [menu, setMenu] = useState("home");
  const menuRef = useRef();

  const dropdown_toggle = () => {
    menuRef.current.classList.toggle("nav-menu-visible");
  };

  const routes = {
    Home: "/",
    AI: "/ai",
    "Graphics Template": "/graphics",
    "Media Template": "/media",
    "Tech Space": "/tech",
    Tutorials: "/tutorials",
  };

  return (
    <div className="nav">
      {/* LOGO */}
      <Link to="/" onClick={() => setMenu("home")} className="nav-logo">
        <img src={logo} alt="logo" />
      </Link>

      {/* MOBILE MENU ICON */}
      <img
        onClick={dropdown_toggle}
        className="nav-dropdown"
        src={nav_dropdown}
        alt="menu"
      />

      {/* NAV LINKS */}
      {/* <ul ref={menuRef} className="nav-menu">
        {Object.keys(routes).map((item) => (
          <li key={item} onClick={() => setMenu(item)}>
            <Link to={routes[item]}>{item}</Link>
            {menu === item && <hr />}
          </li>
        ))}
      </ul> */}
<ul ref={menuRef} className="nav-menu">
  {Object.keys(routes).map((item) => (
    <li
      key={item}
      onClick={() => {
        setMenu(item);
        // ✅ Close menu on mobile when clicking a link
        if (menuRef.current.classList.contains("nav-menu-visible")) {
          menuRef.current.classList.remove("nav-menu-visible");
        }
      }}
    >
      <Link to={routes[item]}>{item}</Link>
      {menu === item && <hr />}
    </li>
  ))}
</ul>
      {/* RIGHT SIDE */}
      <div className="nav-right">
        {localStorage.getItem("auth-token") ? (
          <button
            onClick={() => {
              localStorage.removeItem("auth-token");
              window.location.replace("/");
            }}
          >
            Logout
          </button>
        ) : (
          <Link to="/login">
            <button>Login</button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Navbar;